import React from "react";
import TargetLeadGen from "../../assets/images/sales-prof/target_lead_gen.png";
import TimeSavingAuto from "../../assets/images/sales-prof/time-saving.png";
import SeamlessCRMinte from "../../assets/images/sales-prof/seamlessCrmInte.png";
import comprehensiveLeadProfiles from "../../assets/images/sales-prof/comprehensiveLeadProfs.png";
import ImprovedFollowEffi from "../../assets/images/sales-prof/ImprovedFollowUpEffi.png";
import RealTimeAnalytics from "../../assets/images/sales-prof/realTimeAna.png";
import CollabMadeEasy from "../../assets/images/sales-prof/CollabMadeEasy.png";

const features = [
  {
    title: "Targeted Lead Generation",
    desc: "BeyondLeadz helps you identify and capture high-quality leads that match your ideal customer profile. With advanced segmentation and filtering options, you can focus your efforts on prospects that are most likely to convert.",
    img: TargetLeadGen,
  },
  {
    title: "Time-Saving Automation",
    desc: "Automate routine tasks like lead capturing, data entry, follow-ups, and scheduling, freeing up more time for meaningful interactions with your prospects.",
    img: TimeSavingAuto,
  },
  {
    title: "Seamless CRM Integration",
    desc: "BeyondLeadz integrates effortlessly with your existing CRM, ensuring that your lead data is always up-to-date and accessible. No more switching between multiple platforms—everything you need is in one place.",
    img: SeamlessCRMinte,
  },
  {
    title: "Comprehensive Lead Profiles",
    desc: "Gain deeper insights into your leads with enriched data, including detailed contact information, company details, and behavioural analytics. This allows you to tailor your approach and create personalised pitches that resonate.",
    img: comprehensiveLeadProfiles,
  },
  {
    title: "Improved Follow-Up Efficiency",
    desc: "Set reminders, automate follow-up sequences, and track engagement to ensure no lead falls through the cracks. With Leadz, you can nurture your leads effectively, turning interest into sales.",
    img: ImprovedFollowEffi,
  },
  {
    title: "Real-Time Analytics",
    desc: "Monitor your sales performance with real-time analytics and reporting. Track key metrics like conversion rates, lead sources, and sales pipeline progress to make data-driven decisions and refine your strategy.",
    img: RealTimeAnalytics,
  },
  {
    title: "Collaboration Made Easy",
    desc: "Share leads, notes, and insights with your team in real time, ensuring everyone is on the same page. Collaboration has never been easier, enabling a more cohesive and effective sales approach.",
    img: CollabMadeEasy,
  },
];

const FeaturesList = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-5xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-20">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Empower Your Sales Process
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Why Sales Professionals <br />
            Should Use <span className="tw-text-[#5D44FF]">BeyondLeadz</span>
          </h2>
        </div>

        {/* Alternating Layout Blocks */}
        <div className="tw-space-y-12">
          {features.map((item, idx) => {
            const isEven = idx % 2 === 0;
            return (
              <div
                key={idx}
                className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-[32px] tw-p-8 sm:tw-p-10 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-300"
              >
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-8 tw-items-center">
                  
                  {/* Text Container */}
                  <div className={`md:tw-col-span-7 tw-text-left ${isEven ? "md:tw-order-1" : "md:tw-order-2"}`}>
                    <div className="tw-inline-block tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-mb-3">
                      Feature 0{idx + 1}
                    </div>
                    <h3 className="tw-text-lg sm:tw-text-xl tw-font-extrabold tw-text-slate-800 tw-mb-4">
                      {item.title}
                    </h3>
                    <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                      {item.desc}
                    </p>
                  </div>

                  {/* Image Container */}
                  <div className={`md:tw-col-span-5 tw-flex tw-justify-center ${isEven ? "md:tw-order-2" : "md:tw-order-1"}`}>
                    <div className="tw-overflow-hidden tw-rounded-2xl tw-bg-slate-50 tw-p-2 tw-border tw-border-solid tw-border-slate-100 tw-shadow-sm hover:tw-scale-[1.03] tw-transition-transform tw-duration-300">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="tw-max-w-full tw-h-auto tw-object-contain tw-rounded-lg"
                        loading="lazy"
                      />
                    </div>
                  </div>

                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default FeaturesList;
